"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Rectangle_1 = require("../Utility/Rectangle");
class RectangleFactory {
    static elementRect(element, relativeTo) {
        const pos = element.getPosition(relativeTo);
        return new Rectangle_1.default(pos.x, pos.y, element.getWidth('outer'), element.getHeight('outer'));
    }
}
exports.default = RectangleFactory;
//# sourceMappingURL=RectangleFactory.js.map